(function () {
  'use strict';

  // ── State ──────────────────────────────────────────────────────────────────
  let currentBooking = {
    locationGid:  null,
    startDate:    null,
    endDate:      null,
    locationData: null,
  };

  // ── Boot ───────────────────────────────────────────────────────────────────
  /*  dev-build 222 — pills come from Collection groups (sections/collection-split.liquid).
      Each .cs-group has one .cs-fg per Filter group. A card shows when, in EVERY filter
      group, the selection is "All" (null) or the card carries that Filter. */
  function init() {
    document.querySelectorAll('.cs-group').forEach(setupGroup);
    document.addEventListener('click', e => {
      if (!e.target.closest('.cs-fg--drop')) closeMenus(null);
    });
    document.addEventListener('bookingbar:changed', onBookingBarChanged);

    /* Phone photo swipe (4a). dev-build 232 (Ben, 28-09-2026): rebuilt on touch events.
       231 used CSS scroll-snap and jumped the scroll position back when the loop came
       round; phones ignore a scroll position set during a flick, so the loop stalled after
       one round. Now the photos slide on a transform, driven by the finger, and a swipe in
       either direction always shows the other photo:
         0 first · 1 second · 2 copy of first (added by prepSwipe)
       Left from 1 slides to 2, then snaps to 0 without animating. Right from 0 snaps to 2
       first, then slides to 1. Vertical page scrolling is left to the browser
       (touch-action: pan-y in the CSS). */
    prepSwipes();
    const phone = window.matchMedia('(max-width: 767px)');
    let drag = null;
    const setIndex = (track, i, animate) => {
      track.classList.toggle('pc-no-anim', !animate);
      track.style.setProperty('--pc-i', i);
      track.style.setProperty('--pc-dx', '0px');
      track.dataset.pcIndex = i;
      const fig = track.closest('.pc-swipe');
      if (fig) fig.classList.toggle('is-second', i === 1);
      if (!animate) { void track.offsetWidth; track.classList.remove('pc-no-anim'); }
    };
    document.addEventListener('touchstart', e => {
      if (!phone.matches || e.touches.length !== 1) return;
      const track = e.target.closest && e.target.closest('.pc-swipe .product-featured-image-link');
      if (!track) return;
      prepSwipe(track);
      const t = e.touches[0];
      drag = { track, x: t.clientX, y: t.clientY, dx: 0, dir: null };
    }, { passive: true });
    document.addEventListener('touchmove', e => {
      if (!drag) return;
      const t = e.touches[0];
      const dx = t.clientX - drag.x, dy = t.clientY - drag.y;
      if (!drag.dir && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) drag.dir = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (drag.dir !== 'x') return;
      drag.dx = dx;
      drag.track.classList.add('pc-dragging');
      drag.track.style.setProperty('--pc-dx', dx + 'px');
    }, { passive: true });
    const endDrag = () => {
      if (!drag) return;
      const { track, dx, dir } = drag;
      drag = null;
      track.classList.remove('pc-dragging');
      if (dir !== 'x') return;
      if (Math.abs(dx) > 10) track.dataset.pcDragged = '1';
      const i = Number(track.dataset.pcIndex || 0);
      if (Math.abs(dx) < 40) { setIndex(track, i, true); return; }
      if (dx < 0) {
        const next = i + 1;
        setIndex(track, next, true);
        if (next === 2) setTimeout(() => setIndex(track, 0, false), 300);
      } else if (i === 0) {
        setIndex(track, 2, false);
        requestAnimationFrame(() => setIndex(track, 1, true));
      } else {
        setIndex(track, 0, true);
      }
    };
    document.addEventListener('touchend', endDrag, { passive: true });
    document.addEventListener('touchcancel', endDrag, { passive: true });
    // A swipe must not also open the product.
    document.addEventListener('click', e => {
      const track = e.target.closest && e.target.closest('.pc-swipe .product-featured-image-link');
      if (track && track.dataset.pcDragged) { e.preventDefault(); e.stopPropagation(); delete track.dataset.pcDragged; }
    }, true);
  }

  // ── Phone photo swipe: add the looping copy of the first photo (dev-build 231) ──
  function prepSwipe(track) {
    if (!track || track.querySelector('.pc-swipe-clone')) return;
    const first = track.querySelector('.product-primary-image');
    if (!first) return;
    const copy = first.cloneNode(true);
    copy.classList.remove('product-primary-image');
    copy.classList.add('pc-swipe-clone');
    copy.setAttribute('alt', '');
    copy.setAttribute('aria-hidden', 'true');
    track.appendChild(copy);
  }
  function prepSwipes() {
    document.querySelectorAll('.pc-swipe .product-featured-image-link').forEach(prepSwipe);
  }

  // ── Booking bar ────────────────────────────────────────────────────────────
  function onBookingBarChanged(e) {
    const { locationGid, startDate, endDate } = e.detail || {};

    if (startDate && endDate) {
        window.bookingDates = { start: startDate, end: endDate };
    }

    updateAllCards();
  }

  // ── Update all cards ───────────────────────────────────────────────────────
  function updateAllCards() {
    document.querySelectorAll('.cs-grid__item').forEach(item => updateCard(item));
  }

  // ── Update one card ────────────────────────────────────────────────────────
  function updateCard(item) {
    const startDate      = window.bookingDates?.start;
    const endDate        = window.bookingDates?.end;
    const activeLocation = $('.bb-panel-location.active').data('location');
    const locationData   = window.locationMetaobjects?.[activeLocation] || null;
    const hasBooking = startDate && endDate && locationData;
    const isPackage  = item.dataset.card === 'package';   // dev-build 222: set per card, from the product Type

    applyOverrideBadge(item);

    if (!hasBooking) {
      resetCard(item, isPackage);
      return;
    }

    const { nightsCharged, freeLabels } = computeNights(startDate, endDate, locationData);
    const price     = resolvePrice(item, nightsCharged);
    const bookedOut = isBookedOut(item);

    /* Prompt text, e.g. "1 night charged · Sundays and Labour Day free"

       This used to push one part per label, so two free nights read
       "Sundays free · Labour Day free" — the word "free" repeated, joined by a middot
       that reads as a separator between unrelated facts rather than a list.

       The reasons are now one phrase with one "free" at the end. Oxford-comma-free
       "and" for two, comma-separated with a final "and" for three or more. */
    const promptParts = [`${nightsCharged} ${nightsCharged === 1 ? 'night' : 'nights'} charged`];
    if (freeLabels.length === 1) {
      promptParts.push(`${freeLabels[0]} free`);
    } else if (freeLabels.length === 2) {
      promptParts.push(`${freeLabels[0]} and ${freeLabels[1]} free`);
    } else if (freeLabels.length > 2) {
      const last = freeLabels[freeLabels.length - 1];
      const rest = freeLabels.slice(0, -1).join(', ');
      promptParts.push(`${rest} and ${last} free`);
    }
    const promptText = promptParts.join(' · ');

    if (isPackage) {
      // ── Price ────────────────────────────────────────────────
      const priceEl = item.querySelector('.packages-pc_price');
      if (priceEl && price !== null) {
        priceEl.textContent = formatMoney(price);
      }
      /* dev-build 225: the words beside the price are their own span now. */
      const perEl = item.querySelector('.packages-pc_per');
      if (perEl) perEl.textContent = 'for your dates';

      // ── Prompt ───────────────────────────────────────────────
      const promptEl = item.querySelector('.packages-pc_prompt');
      if (promptEl) {
        promptEl.textContent = promptText;
        promptEl.style.display = '';
      }

    } else {
      // ── Price ────────────────────────────────────────────────
      const priceEl = item.querySelector('.items-pc_price');
      if (priceEl && price !== null) {
        priceEl.textContent = formatMoney(price);
      }

      // ── Prompt — hide ────────────────────────────────────────
      // ── Unit ─────────────────────────────────────────────────
      const unitEl = item.querySelector('.items-pc_unit');
      if (unitEl) {
        const prefix = bookedOut ? 'for this hire' : 'for your dates';
        unitEl.textContent = `${prefix} · ${promptText}`;
      }

      // ── Footer/CTA ──────────────────────────────────────────────────
      const footerEl = item.querySelector('.items-pc_footer');
      const ctaEl = item.querySelector('.items-pc_cta');

      // Remove previous effect classes
      footerEl?.classList.remove('item--booked', 'item--low-stock', 'item--notice', 'item--substitute');

      if (ctaEl) {
        if (bookedOut) {
          footerEl?.classList.add('item--booked');
          /*  dev-build 222 — "See similar" removed (Ben: it must not exist in any design).
              A booked-out card keeps the plain View button. */
          ctaEl.childNodes[0].textContent = (window.csSection?.card_cta || 'View') + ' ';
        } else {
          ctaEl.childNodes[0].textContent = (window.csSection?.card_cta || 'View') + ' ';
        }
      }
    }
  }

  // ── Reset card to static state ─────────────────────────────────────────────
  function resetCard(item, isPackage) {
    if (isPackage) {
      const priceEl = item.querySelector('.packages-pc_price');
      if (priceEl) priceEl.textContent = priceEl.dataset.base;

      /* dev-build 225: no prompt before dates; the line is emptied and hidden, and
         "for 1 night" goes back beside the price. */
      const perEl = item.querySelector('.packages-pc_per');
      if (perEl) perEl.textContent = 'for 1 night';

      const promptEl = item.querySelector('.packages-pc_prompt');
      if (promptEl) {
        promptEl.textContent = '';
        promptEl.style.display = 'none';
      }
    } else {
      const priceEl = item.querySelector('.items-pc_price');
      if (priceEl) priceEl.textContent = priceEl.dataset.base;

      const unitEl = item.querySelector('.items-pc_unit');
      /* dev-build 224: "per unit" moved to the Price per suffix beside the price. */
      if (unitEl) unitEl.textContent = 'for 1 night';

      const ctaEl = item.querySelector('.items-pc_cta');
      if (ctaEl && ctaEl.childNodes[0]) {
        ctaEl.childNodes[0].textContent = (window.csSection?.card_cta || 'View') + ' ';
      }
    }
  }

  /* computeNights / isClosedDay / getFreeLabel moved to assets/charged-nights.js
     One implementation, shared by this file, pp-product.js, collection-split.js and
     pb-cart.js, and matching snippets/charged-nights.liquid. Loaded in theme.liquid
     before this file, so the unqualified calls below resolve to it. Do not re-add a
     local copy. */

  // ── Resolve price ──────────────────────────────────────────────────────────
  function resolvePrice(item, nightsCharged) {
    const productGid = item.dataset.productGid || '';
    const productId  = productGid.replace('gid://shopify/Product/', '');
    const data       = window.csProductData?.[productId];
    if (!data) return null;

    const { hirePeriods, variants } = data;
    if (!hirePeriods?.length || !variants?.length) return null;

    const rung = hirePeriods.find(r => nightsCharged >= r.from && nightsCharged <= r.to);
    if (!rung) return null;

    // Case-insensitive match
    const needle = rung.variant_option.toLowerCase();
    const variant = variants.find(v => v.option.toLowerCase() === needle);
    if (!variant) return null;

    return variant.price;
  }

  // ── Format money ───────────────────────────────────────────────────────────
  function formatMoney(cents) {
    const dollars = cents / 100;
    return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
  }

  // ── Is booked out ──────────────────────────────────────────────────────────
  /*  ── THE BOOKING CONTEXT, ONCE ─────────────────────────────────────────────
      isBookedOut and applyOverrideBadge both derived these five values, identically,
      once per card. Two copies of a derivation is two chances to change one of them.  */
  function blackoutContext() {
    const activeLocation = $('.bb-panel-location.active').data('location');
    const locData        = window.locationMetaobjects?.[activeLocation];
    return {
      start: window.bookingDates?.start,
      end:   window.bookingDates?.end,
      locationGid: locData
        ? (String(locData.gid).startsWith('gid://') ? locData.gid : `gid://shopify/Metaobject/${locData.gid}`)
        : null,
    };
  }

  /*  ── REPOINTED ONTO THE SHARED BLACKOUT RULE, dev-build 184 ───────────────────
      Same three faults as the other two surfaces: the date test read nights_from /
      nights_to, renamed in dev-build 182, so it never ran and a blacked-out product
      showed Booked out on every date; a record with no locations was skipped instead
      of applying everywhere; and the overlap was days rather than nights.

      ONE THING DELIBERATELY NOT ADDED. A package is NOT booked out because one option
      inside it is — confirmed 22-09-2026. It stays bookable with that choice gone, and
      the customer meets it on the product page. So this reads .blocked and never
      .optionsOut: reading the option list as a verdict is what would mark a whole pack
      unavailable because one uplight model is in for repair.                          */
  function isBookedOut(item) {
    const B = window.DJWBlackout;
    if (!B) return false;
    const { start, end, locationGid } = blackoutContext();
    if (!start || !end) return false;
    return B.productBlocked(item.dataset.productGid, start, end, locationGid);
  }

  // ── Override badge ─────────────────────────────────────────────────────────
  function applyOverrideBadge(item) {
    const badgeEl = item.querySelector('.product-card--badges');
    if (!badgeEl) return;

    // Remove previous dynamic badges
    badgeEl.querySelectorAll('.pc-badge').forEach(b => b.remove());

    const { start, end, locationGid } = blackoutContext();
    /* dev-build 230 (option 4e): before dates are picked the card says so, in a grey pill
       in the same spot the Available / Booked out pill takes once dates are set.
       Phones get the short wording (CSS swaps the two spans). */
    if (!start || !end) {
      const badge = document.createElement('span');
      badge.className = 'pc-badge badge--setdates';
      badge.innerHTML = '<svg class="badge-cal" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4.5" width="18" height="16" rx="2.5"/><path d="M3 9.5h18M8 2.5v4M16 2.5v4"/></svg>'
        + '<span class="badge-long">Set dates for availability</span><span class="badge-short">Set dates</span>';
      badgeEl.prepend(badge);
      return;
    }

    const B = window.DJWBlackout;
    const overrides = window.csOverrides;

    /*  The block badge comes from the shared rule, so the badge and the greyed card
        below it can never disagree — they are the same answer asked twice rather than
        two answers. The other three effects keep their own loop, because they carry a
        merchant's message rather than a verdict, but they take the date and location
        tests from the same rule.                                                      */
    if (B && B.productBlocked(item.dataset.productGid, start, end, locationGid)) {
      const badge = document.createElement('span');
      badge.className = 'pc-badge badge--bookedout';
      badge.innerHTML = '<span class="badge-mark"></span>Booked out';
      badgeEl.prepend(badge);
      return;
    }

    if (!B || !Array.isArray(overrides) || !overrides.length) {
      showAvailableBadge(badgeEl);
      return;
    }

    const productGid = item.dataset.productGid;

    for (const override of overrides) {
      if (override.effect === 'block') continue;
      if (!override.products?.length) continue;

      const targetsProduct = override.products.some(p =>
        String(p).split('/').pop() === String(productGid).split('/').pop()
      );
      if (!targetsProduct) continue;

      if (!B.locationApplies(override, locationGid)) continue;
      if (!B.hireHitsRecord(start, end, override)) continue;

      /*  455 (Ben 15-10-2026): the badge names the status, whether or not the record has
          a message. The message belongs to the booking card only. */
      const label = { substitute: 'One swap', low_stock: 'Low stock', notice: 'Good to know' }[override.effect];
      if (label) {
        const badge = document.createElement('span');
        badge.className = 'pc-badge ' + (override.effect === 'substitute' ? 'badge--substitute' : 'badge--override badge--' + override.effect);
        badge.innerHTML = '<span class="badge-mark"></span>' + label;
        badgeEl.prepend(badge);
        return;
      }
    }

    showAvailableBadge(badgeEl);
  }

  // No matching override — show available
  function showAvailableBadge(badgeEl) {
    const badge = document.createElement('span');
    badge.className = 'pc-badge badge--available';
    badge.innerHTML = '<span class="badge-mark"></span>Available';
    badgeEl.prepend(badge);
  }

  // ── Filters (dev-build 222) ───────────────────────────────────────────────
  const hasFilter = (item, key) => (item.dataset.filters || '').indexOf('|' + key + '|') >= 0;

  function setupGroup(group) {
    const items = [...group.querySelectorAll('.cs-grid__item')];
    const fgs = [...group.querySelectorAll('.cs-fg')];
    group._csState = fgs.map(() => null);

    fgs.forEach((fg, i) => {
      const showAll = fg.dataset.showAll !== 'false';
      const chips = [...fg.querySelectorAll('.cs-chip[data-filter]')].filter(c => c.dataset.filter);
      // A Filter that matches none of this group's cards is hidden. With "All" on, one
      // that matches every card is hidden too: it would do the same as "All".
      chips.forEach(c => {
        const n = items.filter(it => hasFilter(it, c.dataset.filter)).length;
        c.hidden = n === 0 || (showAll && n === items.length);
      });
      const live = chips.filter(c => !c.hidden);
      if (!live.length) { fg.hidden = true; return; }
      group._csState[i] = showAll ? null : live[0].dataset.filter;

      fg.querySelectorAll('.cs-chip').forEach(c => c.addEventListener('click', e => {
        e.stopPropagation();
        select(group, fg, i, c.dataset.filter || null);
      }));
      const btn = fg.querySelector('.cs-drop');
      if (btn) btn.addEventListener('click', e => {
        e.stopPropagation();
        // With "All" on, a chosen dropdown shows a cross: tapping it clears the choice.
        if (showAll && group._csState[i]) { select(group, fg, i, null); return; }
        const open = !fg.classList.contains('is-open');
        closeMenus(null);
        if (open) { fg.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      });
      const back = fg.querySelector('.cs-drop__backdrop');
      if (back) back.addEventListener('click', e => { e.stopPropagation(); closeMenus(null); });
      paint(fg, group._csState[i]);
    });
    apply(group);
  }

  function select(group, fg, i, key) {
    group._csState[i] = key;
    paint(fg, key);
    closeMenus(null);
    apply(group);
  }

  function paint(fg, key) {
    fg.querySelectorAll('.cs-chip').forEach(c => c.classList.toggle('is-active', (c.dataset.filter || null) === key));
    const btn = fg.querySelector('.cs-drop');
    if (!btn) return;
    const chosen = key ? fg.querySelector('.cs-chip[data-filter="' + key + '"]') : null;
    btn.querySelector('.cs-drop__text').textContent = chosen ? fg.dataset.label + ': ' + chosen.textContent.trim() : fg.dataset.label;
    btn.classList.toggle('is-active', !!chosen);
    btn.classList.toggle('is-clearable', !!chosen && fg.dataset.showAll !== 'false');
  }

  function closeMenus(except) {
    document.querySelectorAll('.cs-fg--drop.is-open').forEach(fg => {
      if (fg === except) return;
      fg.classList.remove('is-open');
      const b = fg.querySelector('.cs-drop'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  function apply(group) {
    const st = group._csState || [];
    group.querySelectorAll('.cs-grid__item').forEach(item => {
      item.style.display = st.every(k => !k || hasFilter(item, k)) ? '' : 'none';
    });
  }

  /*  dev-build 251 — cards that arrive after load (the "Don't miss these!" section on
      product and cart pages, which the theme fetches and swaps in). Their prices come as
      JSON because a script in swapped HTML never runs. refresh() is safe to call twice. */
  function absorbData(root) {
    window.csProductData = window.csProductData || {};
    root.querySelectorAll('script[data-cs-product-data]').forEach(s => {
      if (s.dataset.csRead) return;
      s.dataset.csRead = '1';
      try { Object.assign(window.csProductData, JSON.parse(s.textContent)); } catch (e) {}
    });
  }
  function refresh(root) {
    root = root || document;
    absorbData(root);
    root.querySelectorAll('.pc-swipe .product-featured-image-link').forEach(prepSwipe);
    root.querySelectorAll('.cs-grid__item').forEach(item => updateCard(item));
  }
  function watchLateCards() {
    document.querySelectorAll('product-recommendations').forEach(el => {
      if (el.dataset.csWatched) return;
      el.dataset.csWatched = '1';
      if (el.querySelector('.cs-grid__item')) refresh(el);
      new MutationObserver(() => refresh(el)).observe(el, { childList: true });
    });
  }

  window.applyOverrideBadge = applyOverrideBadge;
  window.csRefresh           = refresh;
  window.updateAllCards      = updateAllCards;
  window.updateCard          = updateCard;

  // ── Run ────────────────────────────────────────────────────────────────────
  const boot = () => { init(); watchLateCards(); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();